var map = {
	"./atai/photo.jpg": 87,
	"./bi/BI.webp": 88,
	"./data-overflow-6/computer-vision/image1.png": 89,
	"./data-overflow-6/computer-vision/image2.png": 90,
	"./data-overflow-6/computer-vision/image3.png": 91,
	"./data-overflow-6/dataQuest/image1.png": 92,
	"./data-overflow-6/dataQuest/image2.png": 93,
	"./data-overflow-6/dataQuest/image3.png": 94,
	"./data-overflow-6/dataQuest/image4.png": 95,
	"./data-overflow-6/dataQuest/image5.png": 96,
	"./data-overflow-6/ml/image1.png": 97,
	"./data-overflow-6/ml/image2.png": 98,
	"./data-overflow-6/ml/image3.png": 99,
	"./data-overflow-6/nvidia/image1.png": 100,
	"./data-overflow-6/nvidia/image2.png": 101,
	"./data-overflow-6/nvidia/image3.png": 102,
	"./do/do.webp": 103,
	"./flutter/1.webp": 104,
	"./flutter/2.webp": 105,
	"./hoc/hoc1.webp": 106,
	"./hoc/hoc3.webp": 107,
	"./ieeeDay/1.webp": 108,
	"./ieeeDay/2.webp": 109,
	"./mobile_project/Mobile.webp": 110,
	"./summerSchool/CP/image1.jpg": 111,
	"./summerSchool/CP/image2.jpg": 112,
	"./summerSchool/CP/image3.jpg": 113,
	"./summerSchool/CP/image4.jpg": 114,
	"./summerSchool/CP/image5.jpg": 115,
	"./summerSchool/flutter/image1.jpg": 116,
	"./summerSchool/flutter/image2.jpg": 117,
	"./summerSchool/flutter/image3.jpg": 118,
	"./summerSchool/flutter/image4.jpg": 119,
	"./summerSchool/flutter/image5.jpg": 120,
	"./summerSchool2025/ai-for-sw/image1.png": 121,
	"./summerSchool2025/ai-for-sw/image2.png": 122,
	"./summerSchool2025/intro-to-IT/image1.png": 123,
	"./summerSchool2025/intro-to-IT/image2.png": 124,
	"./umojahack/1.webp": 125,
	"./umojahack/2.webp": 126,
	"./umojahack/3.webp": 127,
	"./webdev/week1/image1.jpg": 128,
	"./webdev/week1/image2.jpg": 129,
	"./webdev/week1/image3.jpg": 130,
	"./webdev/week1/image4.jpg": 131,
	"./webdev/week1/image5.jpg": 132,
	"./webdev/week2/image1.jpg": 133,
	"./webdev/week2/image2.jpg": 134,
	"./webdev/week2/image3.jpg": 135,
	"./webdev/week2/image4.jpg": 136,
	"./webdev/week2/image5.jpg": 137,
	"./webdev/week2/image6.jpg": 138,
	"./xtreme/image1.jpg": 139,
	"./xtreme/image3.jpg": 140,
	"./xtreme/image4.jpg": 141,
	"./xtreme/image5.jpg": 142,
	"./xtreme/image6.jpg": 143,
	"./xtreme2025/image1.png": 144,
	"./xtreme2025/image2.png": 145,
	"./xtreme2025/image3.png": 146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;